import useSWR from 'swr';
import { backendClient } from '@/lib/api-client';

export interface StageProgress {
  done: number;
  total: number;
}

export interface ChronologyRefreshStatus {
  chronology_id: string;
  name: string;
  chronology_type: string;
  synced_to_latest_trunk: boolean;
  projected_documents: number;
  available_documents: number;
}

export interface PipelineProgress {
  total_documents: number;
  scope?: {
    total: number;
    included: number;
    queued: number;
    processing: number;
    current: number;
    removing: number;
  };
  processing: boolean;
  stages: {
    interpreted: StageProgress;
    extracted: StageProgress;
    linked: StageProgress;
    entities_consolidated: StageProgress;
    chronology_consolidated: StageProgress;
  };
  projections: ChronologyRefreshStatus[];
}

export function usePipelineProgress(matterGuid: string | undefined) {
  const { data, error, isLoading, mutate } = useSWR(
    matterGuid ? `/matters/${matterGuid}/pipeline-progress` : null,
    async (url: string) => {
      const response = await backendClient.get(url);
      return response.data as PipelineProgress;
    },
    {
      dedupingInterval: 5000,
      refreshInterval: (latestData: PipelineProgress | undefined) =>
        latestData?.processing
        || latestData?.projections?.some(projection => !projection.synced_to_latest_trunk)
          ? 8000
          : 0,
    }
  );

  return {
    progress: data ?? null,
    isLoading,
    isError: !!error,
    mutate,
  };
}
